/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */

import { Icon, InputText, Modal, TextArea } from "@bluframe/blublocks"
import ActionsAndInfoSideBar from "components/ActionsAndInfoSideBar"
import Button from "components/buttons/Button"
import ConfirmModal from "components/ConfirmModal"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"
import {
  Form,
  InputAndButton,
  Main,
  Top
} from "components/List/ItemView/styled"
import { socialsPlatformServiceNameLabels } from "config/socialsPlatforms"

import { ComponentProps } from "."

const Item = ({
  actionButtonLabel,
  actionButtonOnClick,
  bioRef,
  countryIdRef,
  isActionButtonLoading,
  isAdd,
  isAdmin,
  isEditMode,
  isEditor,
  isModalOpen,
  item,
  logoImageIdRef,
  modalContent,
  nameRef,
  onGenerateSlug,
  onModalClose,
  onModalConfirmOpen,
  onModalDeleteConfirm,
  onModalPublishToggleConfirm,
  onSubmit,
  outlinedButtonLabel,
  outlinedButtonOnClick,
  slugRef,
  socialsKeysPairs,
  socialsLinksRefs,
  splashImageIdRef
}: ComponentProps) => (
  <Form onSubmit={onSubmit}>
    <Top>
      <Main>
        {item?.id ? (
          <FieldLabelAndValue>
            <FieldLabel>{"ID"}</FieldLabel>

            <FieldValue>{item.id}</FieldValue>
          </FieldLabelAndValue>
        ) : null}

        <FieldRow $items={2}>
          {isEditMode ? (
            <>
              <InputText
                defaultValue={item?.name || ""}
                inputId="name"
                label="Name"
                name="name"
                ref={nameRef}
                required
              />

              <InputAndButton>
                <InputText
                  defaultValue={item?.slug || ""}
                  inputId="slug"
                  label="Slug"
                  name="slug"
                  ref={slugRef}
                  required
                />

                <Button
                  icon={<Icon group="fa6" name="FaRotateLeft" />}
                  iconOnly
                  label="Generate Slug"
                  onClick={onGenerateSlug}
                  outlined
                  transparent
                />
              </InputAndButton>
            </>
          ) : (
            <>
              <FieldLabelAndValue>
                <FieldLabel>{"Name"}</FieldLabel>

                <FieldValue>{item?.name}</FieldValue>
              </FieldLabelAndValue>

              <FieldLabelAndValue>
                <FieldLabel>{"Slug"}</FieldLabel>

                <FieldValue>{item?.slug}</FieldValue>
              </FieldLabelAndValue>
            </>
          )}
        </FieldRow>

        <FieldRow $items={2}>
          {isEditMode ? (
            <InputText
              defaultValue={item?.countryId || ""}
              inputId="countryId"
              label="Country ID"
              name="countryId"
              ref={countryIdRef}
            />
          ) : (
            <FieldLabelAndValue>
              <FieldLabel>{"Country ID"}</FieldLabel>

              <FieldValue>{item?.countryId}</FieldValue>
            </FieldLabelAndValue>
          )}

          {isEditMode ? (
            <InputText
              defaultValue={item?.logoImageId || ""}
              inputId="logoImageId"
              label="Logo Image ID"
              name="logoImageId"
              ref={logoImageIdRef}
              type="number"
            />
          ) : (
            <FieldLabelAndValue>
              <FieldLabel>{"Logo Image ID"}</FieldLabel>

              <FieldValue>{item?.logoImageId}</FieldValue>
            </FieldLabelAndValue>
          )}
        </FieldRow>

        <FieldRow $items={2}>
          {isEditMode ? (
            <InputText
              defaultValue={item?.splashImageId || ""}
              inputId="splashImageId"
              label="Splash Image ID"
              name="splashImageId"
              ref={splashImageIdRef}
              type="number"
            />
          ) : (
            <FieldLabelAndValue>
              <FieldLabel>{"Splash Image ID"}</FieldLabel>

              <FieldValue>{item?.splashImageId}</FieldValue>
            </FieldLabelAndValue>
          )}
        </FieldRow>

        <FieldRow $items={1}>
          {isEditMode ? (
            <TextArea
              defaultValue={item?.bio || ""}
              inputId="bio"
              label="Bio"
              name="bio"
              ref={bioRef}
            />
          ) : (
            <FieldLabelAndValue>
              <FieldLabel>{"Bio"}</FieldLabel>

              <FieldValue>{item?.bio}</FieldValue>
            </FieldLabelAndValue>
          )}
        </FieldRow>

        <FieldLabel>{"Social Links"}</FieldLabel>

        {socialsKeysPairs.map(({ key, row }) => (
          <FieldRow $items={2} key={key}>
            {row.map((platformKey) =>
              isEditMode ? (
                <InputText
                  defaultValue={item?.socialLinks?.[platformKey] || ""}
                  inputId={`socialLinks.${platformKey}`}
                  key={platformKey}
                  label={socialsPlatformServiceNameLabels[platformKey]}
                  name={`socialLinks.${platformKey}`}
                  ref={socialsLinksRefs[platformKey]}
                />
              ) : (
                <FieldLabelAndValue key={platformKey}>
                  <FieldLabel>
                    {socialsPlatformServiceNameLabels[platformKey]}
                  </FieldLabel>

                  <FieldValue>{item?.socialLinks?.[platformKey]}</FieldValue>
                </FieldLabelAndValue>
              )
            )}
          </FieldRow>
        ))}
      </Main>

      <ActionsAndInfoSideBar
        actionButtonLabel={actionButtonLabel}
        actionButtonOnClick={actionButtonOnClick}
        isActionButtonLoading={isActionButtonLoading}
        isAdd={isAdd}
        isAdmin={isAdmin}
        isEditMode={isEditMode}
        isEditor={isEditor}
        item={
          item
            ? {
                createdAt: item.createdAt,
                isPublished: item.isPublished,
                publishedAt: item.publishedAt,
                updatedAt: item.updatedAt
              }
            : undefined
        }
        onModalConfirmOpen={onModalConfirmOpen}
        outlinedButtonLabel={outlinedButtonLabel}
        outlinedButtonOnClick={outlinedButtonOnClick}
      />
    </Top>

    <Modal isOpen={isModalOpen} onClose={onModalClose}>
      {modalContent === "deleteConfirm" && (
        <ConfirmModal
          message={`Are you sure you want to delete?`}
          onClose={onModalClose}
          onConfirm={onModalDeleteConfirm}
        />
      )}

      {modalContent === "publishConfirm" && (
        <ConfirmModal
          message={`Are you sure you want to ${
            item?.isPublished ? "unpublish" : "publish"
          }?`}
          onClose={onModalClose}
          onConfirm={onModalPublishToggleConfirm}
        />
      )}
    </Modal>
  </Form>
)

export default Item
